import React from "react";
import { object, arrayOf, shape, string, func, bool } from "prop-types";
import { connect } from "react-redux";
import { markDocumentReadCarltonForest } from "../redux/actions";
import Onboarding from "../components/CarltonForest/CarltonForestOnboarding";
import { postSSOWCarltonForest } from "../redux/actions/carltonForestActions";

const CarltonForestOnboardingContainer = ({
  readingListDownloads,
  carltonForestOnboarding,
  markDocumentReadFunc,
  carltonForestReadingLoading,
  carltonForestInductionFormStatus,
  postSSOWCarltonForestFunc,
  SSOWLoading,
  SSOWHandBaller,
  SSOWMaterialHandling,
  SSOWItemsLoading,
  carltonForestInductionFormLoading,
}) => {
  return (
    <Onboarding
      readingList={readingListDownloads}
      carltonForestOnboarding={carltonForestOnboarding}
      markDocumentRead={markDocumentReadFunc}
      carltonForestReadingLoading={carltonForestReadingLoading}
      carltonForestInductionFormStatus={carltonForestInductionFormStatus}
      postSSOWCarltonForest={postSSOWCarltonForestFunc}
      SSOWLoading={SSOWLoading}
      SSOWItemsLoading={SSOWItemsLoading}
      SSOWHandBaller={SSOWHandBaller}
      SSOWMaterialHandling={SSOWMaterialHandling}
      carltonForestInductionFormLoading={carltonForestInductionFormLoading}
    />
  );
};

CarltonForestOnboardingContainer.propTypes = {
  markDocumentReadFunc: func.isRequired,
  carltonForestOnboarding: object,
  carltonForestReadingLoading: bool,
  carltonForestInductionFormStatus: string,
  SSOWLoading: string,
  postSSOWCarltonForestFunc: func.isRequired,
  carltonForestInductionFormLoading: bool,
  readingListDownloads: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SSOWHandBaller: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  SSOWMaterialHandling: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
};

const mapStateToProps = (state) => ({
  readingListDownloads: state.core.umbracoContent.carltonForestReadingList,
  carltonForestOnboarding: state.core.app.carltonForestOnboarding,
  carltonForestReadingLoading: state.core.carltonForest.isReadingLoading,
  carltonForestInductionFormStatus:
    state.core.carltonForest.inductionFormStatus,
  SSOWLoading: state.core.carltonForest.ssowFormName,
  SSOWHandBaller: state.core.umbracoContent.SSOWHandBaller,
  SSOWMaterialHandling: state.core.umbracoContent.SSOWMaterialHandling,
  SSOWItemsLoading: state.core.carltonForest.isSSOWLoading,
  carltonForestInductionFormLoading:
    state.core.carltonForest.isInductionFormLoading,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadCarltonForest,
  postSSOWCarltonForestFunc: postSSOWCarltonForest,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(CarltonForestOnboardingContainer);
